// @ vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');
const isEqual = require('lodash/lang/isEqual');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/loanPartialAmortization');
// @ constants
const { FIRST_STEP, WIZARD_FIRST_STEP, WIZARD_SECOND_STEP } = require('constants/index');
// @ helpers
const { formatDate } = require('utilities/dateHelper');

const setInitialState = () => {
    return Immutable.Map().merge({
        steps: [
            { valid: false },
            { hasSignaturePattern: true }
        ],
        accountError: false,
        error: false,
        isFetchingPartialAmortization: false,
        isFetchingPlanAmortization: false,
        inProgress: false,
        willLeave: false,
        visibleStep: WIZARD_FIRST_STEP,
        success: false,
        loanAmortizationParameter: {},
        loanPartialAmortization: {},
        partialAmortizationData: {
            asociatedAccount: {
                codbban: '',
                controlDigit: '',
                country: ''
            },
            intAssociatedAccount: {
                codbban: '',
                controlDigit: '',
                country: ''
            },
            dueDate: '',
            valueDate: '',
            initLimitAmount: {
                badge: '',
                amount: 0
            },
            currentLimitAmount: {
                badge: '',
                amount: 0
            }
        },
        receiptTotal: 0,
        partialAmortizationSimulationData: {
            amount: 0,
            amortizationType: '',
            newFee: 0,
            newDate: '',
            commission: 0,
            percentage: 0,
            isFetching: false,
            simulationStarted: false,
            hasAmountError: false,
            codeError: 0,
            hasRadioGroupError: false,
            simulationDone: false
        },
        savedPartialAmortizationSimulationData: {
            amount: 0,
            amortizationType: '',
            operationProcessId: false
        },
        partialAmortizationDetails: {},
        balance: 0,
        description: '',
        accountNumber: '',
        isInactiveAccount: false,
        contract: {},
        pendingCapital: 0,
        hasEnoughBalance: false,
        loanPartialAmortizationDocument: false,
        loanPartialAmortizationDocumentId: false,
        operationProcessIdInit: false,
        scrollDown: false,
        downloadOrPrintDocument: false,
        feeIndicator: "N",
        dueIndicator: "N",
        selectedRadioButton: '',
    });
};

const mapData = item => {
     const data = {
        asociatedAccount: {
            codbban: get(item, 'cuentaAsociada.codbban', ''),
            controlDigit: get(item, 'cuentaAsociada.digitodecontrol', ''),
            country: get(item, 'cuentaAsociada.pais', ''),
        },
        intAssociatedAccount: {
            codbban: get(item, 'cuentaAsociadaInt.codbban', ''),
            controlDigit: get(item, 'cuentaAsociadaInt.digitodecontrol', ''),
            country: get(item, 'cuentaAsociadaInt.pais', ''),
        },
        dueDate: formatDate(get(item, 'fechaVencimiento', '')),
        valueDate: formatDate(get(item, 'fechaValor', '')),
        initLimitAmount: {
            badge: get(item, 'importeLimtInicial.divisa', ''),
            amount: get(item, 'importeLimtInicial.importe', 0)
        },
        currentLimitAmount: {
            badge: get(item, 'importeLimtActual.divisa', ''),
            amount: get(item, 'importeLimtActual.importe', 0)
        }
    };

    return data;
};

const validateAmmount = (step, amount) => amount >= step.get('pendingCapital') ? 1 : 0;

const validateRadioButton = (amortizationType) => {
    return (amortizationType && amortizationType != '') ? false : true;
};

const validateStep = (state) => {
    const amount = state.getIn(['partialAmortizationSimulationData', 'amount']);
    const simulationDone = state.getIn(['partialAmortizationSimulationData', 'simulationDone']);
    const balance = state.get('balance');
    let valid = true;
    let hasEnoughBalance = false;
    const codeError = validateAmmount(state, amount);
    const hasAmountError = codeError !== 0;
    const amortizationType = state.getIn(['partialAmortizationSimulationData', 'amortizationType']);
    const hasRadioGroupError = validateRadioButton(amortizationType);

    if (hasAmountError || !simulationDone) {
        valid = false;
    } else if (balance < amount) {
        hasEnoughBalance = true;
        valid = false;
    }

    let visibleStep;

    if (isEqual(state.get('visibleStep'), WIZARD_FIRST_STEP)) {
        visibleStep = valid ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP;
    } else {
        visibleStep = WIZARD_FIRST_STEP;
    }

    return state.setIn(['steps', FIRST_STEP, 'valid'], valid)
        .mergeDeep({
            partialAmortizationSimulationData: {
                amount,
                hasAmountError,
                codeError,
                hasRadioGroupError,
                simulationDone
            },
            hasEnoughBalance,
            visibleStep
        });
};

const accountDetails = (step, initialData) => {
    const data = get(initialData, 'data.consAmorcParcial');
    const immAccounts = get(initialData, 'immAccounts');

    const codban = get(data, 'cuentaAsociada.codbban', '');
    const accountNumber = codban.toString().trim();
    let balance = 0;
    let description = '';
    let isInactiveAccount = false;

    let contract = {
        contractNumber: get(data, ['contrato', 'numerodecontrato']),
        product: get(data, ['contrato', 'producto'])
    }

    if (immAccounts && accountNumber) {
        const immAccountsList = immAccounts.get('byOrder');
        const immAccountsById = immAccounts.get('byId');

        immAccountsList.forEach((account) => {
            const immAccount = immAccountsById.get(account);

            if (immAccount.getIn(['ibanComplex', 'codbban']) === accountNumber) {
                balance = immAccount.getIn(['balance', 'amount']);
                description = `${immAccount.get('alias')}`;
                isInactiveAccount = immAccount.get('isInactiveAccount');
                return false;
            }
        });
    }

    return step.mergeDeep({
        accountNumber,
        balance,
        description,
        contract,
        isInactiveAccount,
        pendingCapital: get(data, 'importeLimtActual.importe', '')
    });
};

const validateUpdateAmount = (state, action) => {
    const amount = get(action, 'payload.amount', 0);
    const codeError = validateAmmount(state, amount);
    const amortizationType = amount > 0 ? state.getIn(['partialAmortizationSimulationData', 'amortizationType']) : '';

    return state.mergeDeep({
        partialAmortizationSimulationData: {
            amount: amount,
            amortizationType,
            hasAmountError: codeError !== 0,
            codeError
        }
    });
}

const loanPartialAmortization = handleActions(
    {
        [simpleActions.loanPartialAmortizationWizardSetVisibleStep]: (state, action) =>
            state.set('visibleStep', action.payload.step),
        [simpleActions.loanPartialAmortizationWizardWillCancel]: state =>
            state.set('willLeave', true),
        [simpleActions.loanPartialAmortizationWizardValidateStep]: state =>
            validateStep(state),
        [simpleActions.loanPartialAmortization]: state =>
            state.set('isFetchingPartialAmortization', true),
        [simpleActions.loanPartialAmortizationError]: (state, action) =>
            state.merge({
                error: action.payload.error,
                isFetchingPartialAmortization: false
            }),
        [simpleActions.loanPartialAmortizationSuccess]: (state, action) =>
            state.mergeDeep({
                partialAmortizationData: mapData(get(action, 'payload.response.consAmorcParcial', '')),
                loanPartialAmortization: action.payload.response,
                isFetchingPartialAmortization: false
            }),
        [simpleActions.loanPlanAmortization]: state =>
            state.set('isFetchingPlanAmortization', true),
        [simpleActions.loanPlanAmortizationError]: (state, action) =>
            state.merge({
                error: action.payload.error,
                isFetchingPlanAmortization: false
            }),
        [simpleActions.loanPlanAmortizationSuccess]: (state, action) =>
            state.mergeDeep({
                receiptTotal: get(action, 'payload.response.listaAmortPrestamo.amortPrestamo[0].totalRecibo', 0),
                isFetchingPlanAmortization: false
            }),
        [simpleActions.loanPartialAmortizationWizardClear]: () =>
            setInitialState(),
        [simpleActions.loanSetPartialAmortization]: state =>
            state.set('inProgress', true),
        [simpleActions.loanSetPartialAmortizationError]: state =>
            state.merge({
                error: true,
                inProgress: false
            }),
        [simpleActions.loanSetPartialAmortizationSuccess]: state =>
            state.merge({
                success: true,
                inProgress: false
            }),
        [simpleActions.loanPartialAmortizationLoanData]: (state, action) =>
            state.set('loanAmortizationParameter', action.payload.response),
        [simpleActions.loanPartialAmortizationUpdateAmount]: (state, action) =>
            validateUpdateAmount(state, action),
        [simpleActions.loanPartialAmortizationUpdateAmortizationType]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    amortizationType: get(action, 'payload.response.amortizationType', ''),
                    hasRadioGroupError: validateRadioButton(get(action, 'payload.response.amortizationType', ''))
                }
            }),
        [simpleActions.loanPartialAmortizationUpdateCommission]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    commission: action.payload.commission
                }
            }),
        [simpleActions.loanPartialAmortizationUpdatePercentage]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    percentage: action.payload.tasa ? action.payload.tasa : 0,
                    contractNumberAccount: action.payload.contractNumberAccount
                }
            }),
        [simpleActions.loanPartialAmortizationUpdateNewFee]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    newFee: action.payload.response
                }
            }),
        [simpleActions.loanPartialAmortizationUpdateFinancialLoss]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    financialLoss: action.payload.impPerdida,
                    impLiquidacion: action.payload.impLiquidacion,
                    contractNumberAccount: action.payload.contractNumberAccount
                }
            }),
        [simpleActions.loanPartialAmortizationUpdateNewDate]: (state, action) => 
              state.mergeDeep({
                partialAmortizationSimulationData: {
                    newDate: action.payload.response,
                    newExpirationDate: action.payload.newExpirationDate,
                    valueDate: action.payload.fechaValor,
                }
            }),
        [simpleActions.loanPartialAmortizationAssociatedAccount]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    detallecontratolocal: action.payload.detallecontratolocal
                }
            }),
        [simpleActions.loanPartialAmortizationInitSuccess]: (state, action) =>
            state.mergeDeep({
                operationProcessIdInit: action.payload.operationProcessId
            }),
        [simpleActions.loanPartialAmortizationInitError]: (state, action) =>
            state.mergeDeep({
                error: true
            }),
        [simpleActions.loanPartialAmortizationDocumentSuccess]: (state, action) =>
            state.mergeDeep({
                loanPartialAmortizationDocument: `data:application/pdf;base64,${action.payload.base64}`,
                loanPartialAmortizationDocumentId: action.payload.documentId,
                errorDocument: true,
                isFetchingDocuments: false
            }),
        [simpleActions.loanSimulatePartialResetPdf]: (state, action) =>
            state.mergeDeep({
                loanPartialAmortizationDocument: false,
                loanPartialAmortizationDocumentId: false,
                operationProcessIdInit: false
            }),
        [simpleActions.loanPartialAmortizationReadDocument]: (state, action) =>
            state.merge({
                scrollDown: true,
            }),
        [simpleActions.loanPartialAmortizationDownloadOrPrintDocument]: (state, action) =>
            state.merge({
                downloadOrPrintDocument: true,
            }),

        [simpleActions.loanPartialAmortizationDocumentError]: (state) =>
            state.mergeDeep({
                errorDocument: true,
                isFetchingDocuments: false
            }),
        [simpleActions.loanSimulatePartialAmortization]: state =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    isFetching: true,
                    simulationStarted: true
                }
            }),
        [simpleActions.loanSimulatePartialAmortizationError]: state =>
            state.merge({
                error: true,
                inProgress: false
            }),
        [simpleActions.loanSimulatePartialAmortizationSuccess]: state =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    isFetching: false,
                    simulationDone: true
                }
            }),
        [simpleActions.loanSimulatePartialStandard]: (state, action) =>
            state.mergeDeep({
                partialAmortizationSimulationData: {
                    standard: action.payload.standard,
                    productSubType: action.payload.productSubType

                }
            }),

        [simpleActions.loanPartialAmortizationUpdateModal]: state =>
            state.set('hasEnoughBalance', false),
        [simpleActions.loanPartialAmortizationUpdateAccountDetails]: (state, action) =>
            accountDetails(state, action.payload.response),
        [simpleActions.loanPartialAmortizationAccountsError]: state =>
            state.set('accountError', true),
        [simpleActions.loanPartialAmortizationFeeIndicator]: (state, action) =>
            state.set('feeIndicator', action.payload),
        [simpleActions.loanPartialAmortizationDueIndicator]: (state, action) =>
            state.set('dueIndicator', action.payload),
        [simpleActions.loanPartialAmortizationDetailsSuccess]: (state, action) =>
            state.set('partialAmortizationDetails', action.payload),
        [simpleActions.loanPartialAmortizationDetailsError]: state =>
        state.merge({
            error: true,
            inProgress: false
        }),
        [simpleActions.loanPartialAmortizationSelectedRadioButton]: (state, action) =>
        state.set('selectedRadioButton', action.payload),
        [simpleActions.savedPartialAmortizationSimulationData]: (state, action) =>
        state.mergeDeep({
            savedPartialAmortizationSimulationData: {
                amount: action.payload.amount,
                amortizationType: action.payload.amortizationType,
                operationProcessId: action.payload.operationProcessId
            }
        }),
    },
    setInitialState()
);

module.exports = loanPartialAmortization;
module.exports.setInitialState = setInitialState;
